// src/admin/services/postsService.js
import api from "../../services/api";

export const postsService = {

  async getPosts({
    search = "",
    category = "",
    status = "",
  } = {}) {

    const response = await api.get(
      "/blog/admin/posts/",
      {
        params: {
          search,
          category,
          status,
        },
      }
    );

    return response.data;
  },

  async createPost(formData) {

    const response = await api.post(
      "/blog/admin/posts/",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response.data;
  },

  async getPost(id) {

    const response = await api.get(
      `/blog/admin/posts/${id}/`
    );

    return response.data;
  },

  async updatePost(id, formData) {

    const response = await api.patch(
      `/blog/admin/posts/${id}/`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response.data;
  },

  async deletePost(id) {

    await api.delete(`/blog/admin/posts/${id}/`);
  },

  // 🆕 Image upload service
  async uploadImage(file, onProgress) {
    const formData = new FormData();
    formData.append('image', file);

    const response = await api.post(
      '/blog/admin/upload-image/',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent) => {
          if (onProgress) {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            onProgress(percentCompleted);
          }
        },
      }
    );

    return response.data;
  },

  // 🆕 Delete image service (optional)
  async deleteImage(filename) {
    const response = await api.delete(
      `/blog/admin/upload-image/?filename=${encodeURIComponent(filename)}`
    );
    return response.data;
  },

  // 🆕 Bulk delete images (optional)
  async deleteMultipleImages(filenames) {
    const response = await api.delete(
      '/blog/admin/upload-image/bulk/',
      {
        data: { filenames },
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  },
};